import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';
const RESOURCE = '/api/extranet_users';
export default {
    async getUsers(params){
        return await Api()
            .get(RESOURCE,{params})
            .catch((err) => errorHandler(err, null));
    },
    async getUser(id){
        return await Api()
            .get(`${RESOURCE}/${id}`)
            .catch((err) => errorHandler(err, null));
    },
    async getClientUsers(params, id){
        return await Api()
            .get(`/api/clients/${id}/extranet_users`,{params})
            .catch((err) => errorHandler(err, null));
    },
    async updateUser(id, data){
        return await Api()
            .put(`${RESOURCE}/${id}`, data)
            .catch((err) => errorHandler(err, null));
    },
}
